<template>
  <div class="tag-conten" v-if="type > 0">
    <div class="tag-box" v-for="(item) in list" :key="item.txt" :style="{'color':item.textColor,'background':item.backColor}">{{item.txt}}</div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: [Number, String],
      default: () => 1
    }
  },
  data() {
    return {
      dataset: [{
        type: 1,
        txt: '我',
        textColor: '#00B97E',
        backColor: 'rgba(0,185,126,0.16)'
      }, {
        type: 2,
        txt: '主管',
        textColor: '#509AFF',
        backColor: 'rgba(80,154,255,0.24)'
      }, {
        type: 3,
        txt: '经理',
        textColor: '#509AFF',
        backColor: 'rgba(80,154,255,0.24)'
      }, {
        type: 4,
        txt: '总监',
        textColor: '#509AFF',
        backColor: 'rgba(80,154,255,0.24)'
      }, {
        type: 5,
        txt: '总裁',
        textColor: '#509AFF',
        backColor: 'rgba(80,154,255,0.24)'
      }, {
        type: 6,
        txt: '总裁',
        textColor: '#509AFF',
        backColor: 'rgba(80,154,255,0.24)'
      }, {
        type: 7,
        txt: 'CEO',
        textColor: '#509AFF',
        backColor: 'rgba(80,154,255,0.24)'
      }, {
        type: 8,
        txt: '负责人',
        textColor: '#509AFF',
        backColor: 'rgba(80,154,255,0.24)'
      }],
      list: []
    }
  },
  created() {
    this.list = this.dataset.filter(res => res.type == this.type)
  },
  watch: {
    type() {
      this.list = this.dataset.filter(res => res.type == this.type)
    }
  }
}
</script>
<style lang="scss">
.tag-conten {
  .tag-box {
    height: 24px;
    padding: 0 11px;
    font-size: 12px;
    border-radius: 4px;
    line-height: 24px;
    margin-left: 10px;
  }
}
</style>
